interface ElementAttributes {
  textContent?: string
  [key: string]: string | boolean | undefined
}

export function prefixed(c: string): string {
  const prefix = 'studyflix-embed--'
  return `${prefix}${c}`
}

export function iframe(prefixedClass: string, attributes: ElementAttributes = {}): HTMLElement {
  return prefixedElement('iframe', prefixedClass, attributes)
}

export function div(prefixedClass: string, attributes: ElementAttributes = {}): HTMLElement {
  return prefixedElement('div', prefixedClass, attributes)
}

export function a(prefixedClass: string, attributes: ElementAttributes = {}): HTMLElement {
  return prefixedElement('a', prefixedClass, attributes)
}

function prefixedElement(
  type: string,
  prefixedClass: string,
  attributes: ElementAttributes = {},
): HTMLElement {
  const node = document.createElement(type)
  node.classList.add(prefixed(prefixedClass))

  if (attributes.textContent) {
    node.textContent = attributes.textContent
    delete attributes.textContent
  }

  for (const prop in attributes) {
    const value = attributes[prop]
    if (value !== undefined) {
      node.setAttribute(prop, String(value))
    }
  }

  return node
}
